import { render, staticRenderFns } from "./pInput.vue?vue&type=template&id=2259e0be&scoped=true&"
import script from "./pInput.vue?vue&type=script&lang=js&"
export * from "./pInput.vue?vue&type=script&lang=js&"
import style0 from "./pInput.vue?vue&type=style&index=0&id=2259e0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259e0be",
  null
  
)

export default component.exports